import { PROCESS_STEPS } from "../../data/content";
import { ChapterHeading } from "./ChapterHeading";
import { Reveal } from "./Reveal";

export const Process = () => (
    <section data-testid="process-section" className="py-24 lg:py-32">
        <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
            <ChapterHeading
                label="How It Works"
                title="How It Works"
                sub="A clear six-step journey from first conversation to launch — you always know what happens next."
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
                {PROCESS_STEPS.map((s, i) => (
                    <Reveal key={s.title} delay={(i % 3) * 0.1}>
                        <div
                            data-testid={`process-step-${i}`}
                            className="group relative h-full rounded-2xl border border-white/8 bg-[#0D131F] p-7 overflow-hidden transition-all duration-300 hover:border-[#00E5FF]/40 hover:-translate-y-1"
                        >
                            <span
                                className="absolute -top-3 right-4 font-display text-[5.2rem] font-extrabold leading-none text-white/[0.05] select-none transition-colors duration-500 group-hover:text-[#00E5FF]/10"
                                aria-hidden="true"
                            >
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div className="h-11 w-11 rounded-xl bg-[#00E5FF]/10 border border-[#00E5FF]/25 flex items-center justify-center mb-5 transition-transform duration-300 group-hover:scale-110">
                                <s.icon size={20} className="text-[#00E5FF]" />
                            </div>
                            <p className="font-jbmono text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2">
                                Step {String(i + 1).padStart(2, "0")}
                            </p>
                            <h3 className="font-display text-xl font-semibold text-white">
                                {s.title}
                            </h3>
                            <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
